export default (list, param) => {
  
  if (typeof list !== 'array' && typeof param !== 'number') {
    throw new Error('参数1为Array类型，参数2为数值类型')
  }
  const length = list.length
  const remainder = length % parent
  // 元素数量是可以除尽的
  if (remainder === 0) {
    return
  }
  // 元素数量少于倍数
  const differe = Math.floor(length / param + 1) * param - length
  for( let i = 0; i < differe; i++) {
    list.push({temp: true})
  }
}
